// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1JyNK","buttons":"SendReceipts_buttons__ZSe1r","email":"SendReceipts_email__3YmUm","bookApptTitle":"SendReceipts_bookApptTitle__34h_z"};